import { useEffect } from 'react';
import { Text, Spacer } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import useTracking from 'hooks/useTracking';
import { viewScreenEvent } from 'libs/common/event-tracker/events';
import { Screen } from 'constants/tracking/screens';
import ReCaptcha from './ReCaptcha';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Captcha = _ref => {
  let {
    onComplete
  } = _ref;
  const translate = useTranslate('captcha');
  const {
    track
  } = useTracking();
  useEffect(() => {
    track(viewScreenEvent({
      screen: Screen.CaptchaPage
    }));
  }, [track]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      text: translate('title'),
      type: Text.Type.Heading,
      alignment: Text.Alignment.Center,
      width: Text.Width.Parent
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.XLarge
    }), /*#__PURE__*/_jsx(Text, {
      text: translate('text'),
      alignment: Text.Alignment.Center
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.X2Large
    }), /*#__PURE__*/_jsx(ReCaptcha, {
      onComplete: onComplete
    })]
  });
};

export default Captcha;